import React, { FC, Fragment } from "react";
import { makeStyles, createStyles } from "@material-ui/core";
import { FormControlLabel } from "../core/FormControlLabel";
import { Checkbox } from "../core/Checkbox";
import { useStyles } from "../../useStyles";
import { useFormModel } from "../core/FormModelHelpes";
import { ChangeNames } from "../../clients/FirebaseClient/types";

const useFormControlStyle = makeStyles(() =>
    createStyles({
        container: {
            display: "flex",
            flexDirection: "row",
        },
        formControlLabelCheckboxStyle: {
            width: 300,
        },
        checkboxStyle: {
            marginRight: 8,
        },
    }),
);

export const ModificationPersonalContributionWallBushingForm: FC = () => {
    const classes = useStyles();

    const { values, setValues } = useFormModel<
        ChangeNames.MODIFICATION_PERSONAL_CONTRIBUTION_CAN_DO_WALL_BUSHING
    >();

    const formControlClasses = useFormControlStyle();

    return (
        <Fragment>
            <FormControlLabel
                isCheckBox={true}
                className={formControlClasses.formControlLabelCheckboxStyle}
                control={
                    <Checkbox
                        className={formControlClasses.checkboxStyle}
                        value="PersonalContributionCanDoWallBushing"
                        checked={values.modificationPersonalContributionCanDoWallBushing.value.yes}
                        onChange={(event, checked) =>
                            setValues(values => {
                                if (checked) {
                                    values.modificationPersonalContributionCanDoWallBushing.value.yes = true;
                                    values.modificationPersonalContributionCanDoWallBushing.value.no = false;
                                } else {
                                    values.modificationPersonalContributionCanDoWallBushing.value.yes = false;
                                    values.modificationPersonalContributionCanDoWallBushing.value.no = true;
                                }
                            })
                        }
                    />
                }
                label="Mauerdurchbruch / Kernbohrung"
                error={values.modificationPersonalContributionCanDoWallBushing.error !== null}
            />
            <p
                className={classes.pSmall}
                style={{ marginTop: 10, marginBottom: 15, marginLeft: 44 }}
            >
                Der Mauerdurchbruch bzw. die Kernbohrung kann in Eigenleistung ausgeführt werden.
            </p>
        </Fragment>
    );
};
